var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgIconMaterialFullscreenExit = function SvgIconMaterialFullscreenExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "exit fullscreen_icon",
    width: 40,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58900",
    d: "M5 28.571h6.429V35h4.286V24.286H5zm6.429-17.143H5v4.286h10.714V5h-4.285zM24.286 35h4.286v-6.429H35v-4.285H24.286zm4.286-23.571V5h-4.286v10.714H35v-4.285z",
    fill: "#fff"
  })));
};
export default SvgIconMaterialFullscreenExit;